<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="fmtx1"><i>To Rolf Lassgård with great warmth, gratitude, and not a little admiration. He has told me so much about Wallander that I myself did not know.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595585820_oeb_ded_r1.vue?3d48f54a